module.exports = __webpack_public_path__ + "img/icon-rock.8ce1e109.svg";